module.exports = __webpack_public_path__ + "img/hand.107a4a6d.png";